'use client';

import { useId } from 'react';
import { useIntl } from 'react-intl';

import { FontSizes, FontWeights } from '@calm-web/design-system';

import messages from '@/components/SimplifiedSignup/configs/Control/messages';

import ValuePropsList, { type ValuePropsListProps } from '../ValuePropsList';
import styles from './styles.module.css';

export type PremiumValuePropsListProps = Omit<
	ValuePropsListProps,
	'className' | 'data-testid' | 'gapSize' | 'title' | 'id'
>;

export default function PremiumValuePropsList(valuePropsListProps: PremiumValuePropsListProps) {
	const id = useId();
	const { formatMessage } = useIntl();
	return (
		<ValuePropsList
			{...valuePropsListProps}
			className={styles.premiumValuePropsList}
			data-testid="sisu-premium-value-props-list"
			gapSize="0px"
			id={id}
			title={formatMessage(messages.includedPremium)}
			titleProps={{
				size: FontSizes.lg,
				weight: FontWeights.Regular,
			}}
		/>
	);
}
